import { useTranslation } from 'react-i18next';

import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/cn';
import { formatNumber } from '../../lib/format';
import type { ReportConfidence } from '../../types';

const TONE: Record<ReportConfidence, string> = {
  unconfirmed: 'bg-elevated text-text-secondary',
  corroborated: 'bg-status-success/10 text-emerald-700 dark:text-emerald-300',
  verified: 'bg-brand-primary/10 text-brand-primary',
};

/** How much to trust a community report: a single unconfirmed report must look different from a verified one. */
export function ConfidenceBadge({
  confidence,
  corroborations,
  className,
}: {
  confidence: ReportConfidence;
  corroborations: number;
  className?: string;
}) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const count = corroborations + 1;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', TONE[confidence], className)}>
      {confidence === 'corroborated'
        ? t('trust.confidence.corroborated', { count, n: formatNumber(count, language) })
        : t(`trust.confidence.${confidence}`)}
    </span>
  );
}
